const POSSIBLE_TYPES_QUERY = `
  {
    __schema {
      types {
        kind
        name
        possibleTypes {
          name
        }
      }
    }
  }
`;

export default POSSIBLE_TYPES_QUERY;
